import * as React from 'react';
import MuiAccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { Box, Typography, MuiAccordionDetails, styled, MuiAccordion, Button } from '../../imports/muiImport';

// icons 
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';

// components
import CardDesignForm from './components/CardDesignForm';
import ReceiverDetailsSection from './components/ReceiverDetailsSection';
import PlateformChooseSection from './components/PlateformChooseSection';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, 0.03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    backgroundColor: theme.palette.white.main
}));

export default function GiftCardDesign({ defaultPanel = "panel1" }) {
    const [expanded, setExpanded] = React.useState(defaultPanel);

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: {
                    sm: "100%",
                    md: 700
                },
            }}
        >
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Typography component="span">Design Gift Card</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <CardDesignForm />
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                    <Typography component="span">Receiver Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ReceiverDetailsSection />
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                    <Typography component="span">Choose Share Plateform</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <PlateformChooseSection />
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
